import { FC } from 'react';
import { useTranslation } from 'src/i18n';
import {
  Button,
  Dialog,
  DialogProps,
  ButtonProps,
  DialogTitle,
  DialogTitleProps,
  DialogContent,
  DialogContentProps,
  DialogActions,
  LinearProgress,
} from 'material-hu';

export type AcceptCancelDialogProps = Omit<DialogProps, 'title'> & {
  title?: string | JSX.Element;
  onCancel?: (event) => void;
  onAccept?: (event) => void;
  showCancel?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  acceptLabel?: string;
  cancelLabel?: string;
  titleProps?: DialogTitleProps;
  contentProps?: DialogContentProps;
  enabledTitle?: boolean;
  variantAcceptButton?: ButtonProps['variant'];
  variantCancelButton?: ButtonProps['variant'];
};

export const AcceptCancelDialog: FC<
  React.PropsWithChildren<AcceptCancelDialogProps>
> = props => {
  const {
    children,
    title,
    onCancel,
    onAccept,
    showCancel = false,
    disabled = false,
    isLoading = false,
    acceptLabel,
    cancelLabel,
    titleProps,
    contentProps,
    enabledTitle = true,
    variantAcceptButton,
    variantCancelButton,
    ...dialogProps
  } = props;

  const { t } = useTranslation();

  return (
    <Dialog {...dialogProps}>
      {isLoading && <LinearProgress />}
      {enabledTitle && (
        <DialogTitle {...titleProps}>{title || t('CONFIRM')}</DialogTitle>
      )}
      <DialogContent {...contentProps}>{children}</DialogContent>
      <DialogActions>
        {showCancel && (
          <Button
            variant={variantCancelButton}
            disabled={isLoading}
            onClick={onCancel}
          >
            {cancelLabel || t('CANCEL')}
          </Button>
        )}
        <Button
          variant={variantAcceptButton}
          disabled={disabled || isLoading}
          onClick={onAccept}
        >
          {acceptLabel || t('ACCEPT')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AcceptCancelDialog;
